import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { getFormattedErr } from 'src/helpers';
import apiClient from 'src/helpers/apiClient';

export const fetchDailyMissions = createAsyncThunk(
  'rewards/fetchDailyMissions',
  async (_: void, { rejectWithValue, signal }) => {
    try {
      const api = await apiClient.getDailyMissionApi();
      const response = await api.dailyMissionApiGetMyDailyMissions({ signal });
      return response.data;
    } catch (err: any) {
      // Aborted by a card that unmounted mid-request: nothing went wrong.
      if (err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError') {
        return rejectWithValue({ canceled: true });
      }
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error), {
        variant: 'error',
      });
      return rejectWithValue(err?.response?.data);
    }
  },
);

/**
 * Claim mission XP. Omit `key` to claim every completed mission at once —
 * the usual case, since a learner typically opens the page to several finished
 * at the same time.
 *
 * The response is the whole refreshed board, not just the delta, so the tab
 * lands on server truth rather than a locally patched guess.
 */
export const claimDailyMissions = createAsyncThunk(
  'rewards/claimDailyMissions',
  async ({ key }: { key?: string }, { rejectWithValue }) => {
    if (key !== undefined && !key) {
      return rejectWithValue({ error: 'daily_mission_key_missing' });
    }
    try {
      const api = await apiClient.getDailyMissionApi();
      const response = await api.dailyMissionApiClaimMyDailyMissions({
        claimDailyMissionBody: key ? { key } : {},
      });
      return response.data;
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error), {
        variant: 'error',
      });
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const fetchLevelLadder = createAsyncThunk(
  'rewards/fetchLevelLadder',
  async (_: void, { rejectWithValue, signal }) => {
    try {
      const api = await apiClient.getUserLevelApi();
      const response = await api.userLevelApiGetMyUserLevel({ signal });
      return response.data;
    } catch (err: any) {
      enqueueSnackbar(getFormattedErr(err?.response?.data?.error), {
        variant: 'error',
      });
      return rejectWithValue(err?.response?.data);
    }
  },
);
